export default "/_next/static/chunks/fonts/MinionProSemiboldIt-f5d7b7c8cf54efdd17466d284a70276e.woff2";